import React, { useMemo } from "react";

import InitialDataListPage from "../components/InitialDataListPage";

const ColourMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
}) => {
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "6%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "Colour_Code",
        header: "รหัสสี",
        width: "25%",
        align: "center",
        render: (item) => item.Colour_Code || "-",
      },
      {
        key: "Colour_Name",
        header: "ชื่อสี",
        width: "50%",
        align: "start",
        render: (item) => item.Colour_Name || "-",
      },
      {
        key: "Colour_Status",
        header: "สถานะ",
        width: "13%",
        align: "center",
        render: (item) =>
          item.Colour_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "6%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#E13F57",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#E13F57";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#E13F57";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.Colour_Code,
      item?.Colour_Name,
      item?.Colour_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/tbsetcolour"
      data={masterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder={`ค้นหา${name || "สี"}...`}
      fieldMappings={{ no: "Colour_Id" }}
      getRowId={(item) => item?.Colour_Id}
    />
  );
};

export default ColourMain;
